import { render, staticRenderFns } from "./FormAdress.vue?vue&type=template&id=3e6bcfc4&scoped=true&"
import script from "./FormAdress.vue?vue&type=script&lang=js&"
export * from "./FormAdress.vue?vue&type=script&lang=js&"
import style0 from "./FormAdress.vue?vue&type=style&index=0&id=3e6bcfc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6bcfc4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
